const toggleLandingMenu = (show) => {
    const menu = document.querySelector('.landing-mobile-menu');
    const backdrop = document.querySelector('.landing-header-backdrop');
    const toggle = document.querySelector('.landing-header-menu-toggle');

    if (!menu || !backdrop) return;

    if (show) {
        menu.classList.add('active');
        backdrop.classList.add('active');
        toggle?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        // Focus first link for accessibility
        const firstLink = menu.querySelector('.landing-mobile-link');
        if (firstLink) {
            firstLink.focus();
        }
    } else {
        menu.classList.remove('active');
        backdrop.classList.remove('active');
        toggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
};

const handleMenuToggle = () => {
    const menu = document.querySelector('.landing-mobile-menu');
    const isOpen = menu?.classList.contains('active');
    toggleLandingMenu(!isOpen);
};

const handleMenuClose = () => {
    toggleLandingMenu(false);
};

const handleKeydown = (event) => {
    if (event.key === 'Escape') {
        const menu = document.querySelector('.landing-mobile-menu');
        if (menu?.classList.contains('active')) {
            toggleLandingMenu(false);
        }
    }
};

const initLandingMenu = () => {
    const toggle = document.querySelector('.landing-header-menu-toggle');
    const closeBtn = document.querySelector('.landing-mobile-menu-close');
    const backdrop = document.querySelector('.landing-header-backdrop');

    toggle?.addEventListener('click', handleMenuToggle);
    closeBtn?.addEventListener('click', handleMenuClose);
    backdrop?.addEventListener('click', handleMenuClose);
    document.addEventListener('keydown', handleKeydown);
};

const cleanupLandingMenu = () => {
    const toggle = document.querySelector('.landing-header-menu-toggle');
    const closeBtn = document.querySelector('.landing-mobile-menu-close');
    const backdrop = document.querySelector('.landing-header-backdrop');

    toggle?.removeEventListener('click', handleMenuToggle);
    closeBtn?.removeEventListener('click', handleMenuClose);
    backdrop?.removeEventListener('click', handleMenuClose);
    document.removeEventListener('keydown', handleKeydown);

    // Reset state
    toggleLandingMenu(false);
};

// Track if we've already initialized to prevent double-binding
let landingMenuInitialized = false;

const safeInitLandingMenu = () => {
    // Only initialize if elements exist and we haven't already
    const toggle = document.querySelector('.landing-header-menu-toggle');
    if (toggle && !landingMenuInitialized) {
        landingMenuInitialized = true;
        initLandingMenu();
    }
};

const safeCleanupLandingMenu = () => {
    if (landingMenuInitialized) {
        cleanupLandingMenu();
        landingMenuInitialized = false;
    }
};

// Turbolinks events
document.addEventListener('turbolinks:load', safeInitLandingMenu);
document.addEventListener('turbolinks:before-cache', safeCleanupLandingMenu);

// Handle initial page load (runs after DOM is ready)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInitLandingMenu);
} else {
    // DOM already loaded - defer to next tick to ensure elements are rendered
    setTimeout(safeInitLandingMenu, 0);
}
